if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        /** @type {HTMLFormElement} */
        this.form = /** @type {HTMLFormElement} */ (this.querySelector('form'));
        /** @type {HTMLInputElement} */
        const idInput = /** @type {HTMLInputElement} */ (this.form.querySelector('[name=id]'));
        idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        /** @type {HTMLElement | null} */
        this.cart = /** @type {HTMLElement | null} */ (document.querySelector('cart-notification') || document.querySelector('cart-drawer'));
        /** @type {HTMLButtonElement} */
        this.submitButton = /** @type {HTMLButtonElement} */ (this.querySelector('[type="submit"]'));

        if (document.querySelector('cart-drawer')) {this.submitButton.setAttribute('aria-haspopup', 'dialog');}

        /** @type {boolean} */
        this.hideErrors = this.dataset.hideErrors === 'true';
        /** @type {boolean} */
        this.error = false;
        /** @type {HTMLElement | null} */
        this.errorMessageWrapper = null;
        /** @type {HTMLElement | null} */
        this.errorMessage = null;
      }

      /**
       * @param {SubmitEvent} evt
       */
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {return;}

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        /** @type {HTMLElement} */
        const spinner = /** @type {HTMLElement} */ (this.querySelector('.loading-overlay__spinner'));
        spinner.classList.remove('hidden');

        /** @type {RequestInit & {headers: Record<string, string>}} */
        const config = /** @type {RequestInit & {headers: Record<string, string>}} */ (fetchConfig('javascript'));
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          /** @type {any} */
          const cartElement = this.cart;
          formData.append(
            'sections',
            cartElement.getSectionsToRender().map(/** @param {{id: string}} section */ (section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cartElement.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(/** @param {Response} response */ (response) => response.json())
          .then(/** @param {any} response */ (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              /** @type {HTMLElement | null} */
              const soldOutMessage = /** @type {HTMLElement | null} */ (this.submitButton.querySelector('.sold-out-message'));
              if (!soldOutMessage) {return;}
              this.submitButton.setAttribute('aria-disabled', 'true');
              /** @type {HTMLElement} */
              const buttonSpan = /** @type {HTMLElement} */ (this.submitButton.querySelector('span'));
              buttonSpan.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = /** @type {any} */ (window).routes.cart_url;
              return;
            }

            if (!this.error)
              {publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });}
            this.error = false;
            /** @type {HTMLElement | null} */
            const quickAddModal = /** @type {HTMLElement | null} */ (this.closest('quick-add-modal'));
            if (quickAddModal) {
              /** @type {any} */
              const cartElement = this.cart;
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    cartElement.renderContents(response);
                  });
                },
                { once: true }
              );
              /** @type {any} */ (quickAddModal).hide(true);
            } else {
              /** @type {any} */ (this.cart).renderContents(response);
            }
          })
          .catch(/** @param {Error} e */ (e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {this.cart.classList.remove('is-empty');}
            if (!this.error) {this.submitButton.removeAttribute('aria-disabled');}
            /** @type {HTMLElement} */
            const spinnerEl = /** @type {HTMLElement} */ (this.querySelector('.loading-overlay__spinner'));
            spinnerEl.classList.add('hidden');
          });
      }

      /**
       * @param {string | false} [errorMessage]
       */
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {return;}

        this.errorMessageWrapper =
          this.errorMessageWrapper || /** @type {HTMLElement | null} */ (this.querySelector('.product-form__error-message-wrapper'));
        if (!this.errorMessageWrapper) {return;}
        this.errorMessage = this.errorMessage || /** @type {HTMLElement | null} */ (this.errorMessageWrapper.querySelector('.product-form__error-message'));

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
